import CubeIcon from '@svg/cube';

import { Button, Modal } from '@common/index';
import { Stack } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, FlowCreationModal, FlowModals, State, flowActions, tabActions } from '@store/index';

import { ArchitectureOutlined, DeviceHubOutlined } from '@mui/icons-material';
import { useNavigate, useParams } from 'react-router-dom';
import { SpotlightPanel, SpotlightPanelContainer } from '@common/SpotlightPanels/SpotlightPanels';

export const SelectNewWorkflow: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();

  const { service_id } = useParams();

  const flowCreationModal = useSelector((state: State) => state.flow.modal) as FlowCreationModal;
  if (flowCreationModal === null) return null;

  const type = flowCreationModal.type;
  const variant = flowCreationModal.variant;
  const open = type === FlowModals.SelectNewFlow;

  const closeModal = () => {
    dispatch(tabActions.cancelTabCreation());
    navigate(`/${service_id}/workflow`);
    dispatch(flowActions.setFlowModal(null));
  };

  const openManualModal = () => {
    dispatch(flowActions.setFlowModal({ type: FlowModals.EditFlow }));
  };

  const openSelectTemplateModal = () => {
    dispatch(flowActions.setFlowModal({ type: FlowModals.SelectTemplate, variant }));
  };

  const cards = [
    {
      title: 'Blank Canvas',
      icon:
        variant === 'workflow' ? <DeviceHubOutlined sx={{ fontSize: '2.4ch !important' }} /> : <CubeIcon height={28} />,
      description: `A blank canvas will have zero nodes. You can add nodes by right clicking the canvas. You should add a final Response node if you'd like to return a response to your workflow/module.`,
      onClick: openManualModal,
      intercomDataAttribute: undefined,
      category: 'type',
    },
    {
      title: 'Template',
      icon: <ArchitectureOutlined sx={{ fontSize: '3ch !important' }} />,
      description:
        'A template can be used to quickly create workflows/modules for common use cases. If you select this option you will see a list of templates to choose from in the next modal.',
      onClick: openSelectTemplateModal,
      intercomDataAttribute: 'workflow-template-selection',
      category: 'type',
    },
  ];

  return (
    <Modal
      open={open}
      setOpen={closeModal}
      header='Setup a Canvas'
      background='primary'
      icon={variant === 'workflow' ? <DeviceHubOutlined /> : <CubeIcon height={24} />}
      info={`Start your canvas from a predefined template (ideal for beginners) or create it from scratch.`}
      body={
        <SpotlightPanelContainer>
          {cards.map((card) => (
            <SpotlightPanel key={card.title} card={card} intercomDataAttribute={card.intercomDataAttribute} />
          ))}
        </SpotlightPanelContainer>
      }
      actions={
        <Stack direction='row' spacing={1}>
          <Button small onClick={closeModal}>
            Cancel
          </Button>
        </Stack>
      }
    />
  );
};
